//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { ClientPermissions } from '@/modules/client/client-permissions';
import Roles from '@/security/roles';
import vueI18n from '@/vueI18n'
import { i18n } from '@/vueI18n';
import moment from 'moment';

import { ClientModel } from '@/modules/client/client-model';
const { fields } = ClientModel;

export default {
  name: 'app-client-list-table',

  mounted() {
    this.doFilter();
    this.doMountTable(this.$refs.table);
  },

  data() {
    return {
      filter: '',
      selection: [],
      nextPage: 2,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        // sortBy: 'createdAt',
        // descending: false,
        // rowsNumber: xx if getting data from a server
      },
      columns: [
        {
          name: 'fullName',
          field: 'fullName',
          label: i18n('entities.client.fields.fullName'), 
          align: 'center',
          format: (val) => `${val}`,
          required: true,
          sortable: true,
        },
        {
          name: 'phoneNumber',
          field: 'phoneNumber',
          label: i18n('entities.client.fields.phoneNumber'),
          align: 'center',
        },
        {
          name: 'email',
          field: 'email',
          label: i18n('entities.client.fields.email'),
          align: 'center',
        },
        {
          name: 'points',
          field: 'points',
          label: i18n('entities.client.fields.points'),
          align: 'center',
        },
        {
          name: 'wallet',
          field: 'wallet',
          label: i18n('entities.client.fields.wallet'),
          align: 'center',
        },
        {
          name: 'createdAt',
          field: 'createdAt',
          label: i18n('entities.client.fields.createdAt'),
          align: 'center',
        },
        {
          name: 'status',
          field: 'disabledAsStatus',
          label: i18n('entities.client.fields.status'),
          align: 'center',
        },
        {
          name: 'action',
          field: 'action',
          label:  i18n('common.action'),
          align: 'center',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      rows: 'client/list/rows',
      count: 'client/list/count',
      loading: 'client/list/loading',
      toggleStatusloading: 'iam/view/statusLoading',
      
      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
      // pagination: 'client/list/pagination',
      // paginationLayout: 'layout/paginationLayout',
    }),
    hasPermissionToEdit() {
      return new ClientPermissions(this.currentUser).edit;
    },
    fields() {
      return fields;
    },
    isRTL() {
      return localStorage.getItem('language') == 'ar'
    },
    language(){
      return vueI18n.locale
    },
    pagesNumber () {
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage)
    },
  },
  methods: {
    ...mapActions({
      doChangeSort: 'client/list/doChangeSort',
      doChangePaginationCurrentPage: 'client/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'client/list/doChangePaginationPageSize',
      doMountTable: 'client/list/doMountTable',
      doFetch: 'client/list/doFetch',
      doToggleUserAccountStatus: 'iam/view/doToggleUserAccountStatus'
    }),
    i18n(key, args) {
      // return i18n(key, args);
      return this.$t(key, args);
    },
    roleDescriptionOf(roleId) {
      return Roles.descriptionOf(roleId);
    },
    roleLabelOf(roleId) {
      return Roles.labelOf(roleId);
    },
    presenter(row, fieldName) {
      const val = ClientModel.presenter(row, fieldName);
      return val ? val : 'ـــ';
    },
    presenterEnum(row, fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == row[fieldName])
      return val.length ? val[0].label : 'ـــ';
    },
    presenterMap(row, fieldName) {
      const val = ClientModel.presenter(row, fieldName);
      return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(row, fieldName) {
      const val = ClientModel.presenter(row, fieldName);
      return val ? moment(val).locale(this.currentLanguageCode).format("DD-MM-YYYY h:mm A") : 'ـــ'; 
    },
    presenterDate(val) {
      // const val = ClientModel.presenter(row, fieldName)
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY") : 'ـــــــ'; 
    },
    presenterDay(row, fieldName) {
      return moment(ClientModel.presenter(row, fieldName)).locale(this.currentLanguageCode).format("dddd");
    },
    presenterTime(row, fieldName) {
      // let now = moment().locale('en').format('YYYY/MM/DD');
      // let time = ClientModel.presenter(row, fieldName)
      let val = row[fieldName]
      // let date =  `${now} ${time}`;
      return moment(val, "YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm A')
    },
    presenterClient(row, fieldName, key) {
      const user = ClientModel.presenter(row, fieldName);
      if (key == 'avatars' || key == 'avatar') {
        let avatar = null
        if (user && Array.isArray(user[key])) {
          avatar = user[key].length ? user[key][0].publicUrl : null
        } else if (user && user[key]) {
          avatar = user[key].publicUrl 
        }
        return avatar ? avatar : 'https://firebasestorage.googleapis.com/v0/b/puricom-beebe.appspot.com/o/public%2Fdefault%2Favatar.svg?alt=media&token=439fb6e6-815f-453e-9e3a-79dc0ab3d40c'
      }
      return user && user[key] ? user[key] : 'ـــ'; 
    },
    presenterUser(row, fieldName, key) {
      const val = ClientModel.presenter(row, fieldName);
      return val && val[key] ? val[key] : 'ـــ'; 
    },
    presenterLocalization(data) {
      if (typeof data === 'object' && data !== null) {
        return data[this.currentLanguageCode] ? data[this.currentLanguageCode] : data['en']
        // if (this.currentLanguageCode in data) {
        //   return data[this.currentLanguageCode]
        // }
      }
      return  
    },
    async doFilter() {
      const filter = { accountType: 'client' };
      return this.doFetch({
        filter,
      });
    },
    async toggleAccountStatus(id) {
      console.log(id);
      this.doToggleUserAccountStatus(id)
    },

  },
};
